import axios from 'axios';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { notifyViewStartLoading } from '@wix/business-manager-api';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import { COMPONENT_NAME, IBMModuleParams } from './config';
import i18n from './i18n';
import App from './components/App';
import { CrmHomeBiLogger } from './bi-logger';
import { FontUpgrade } from 'wix-style-react';
import { createExperiments, CrmHomeSpec } from './services/experiments';

wixAxiosConfig(axios, {
  baseURL: '/',
});

interface AppState {
  initialized: boolean;
  isFontUpgrade: boolean;
}

export default class AppContainer extends React.Component<
  IBMModuleParams,
  AppState
> {
  i18n: any;
  state = {
    initialized: false,
    isFontUpgrade: false,
  };

  constructor(props: IBMModuleParams) {
    super(props);
    const { accountLanguage, config } = this.props;
    const baseUrl = config.topology.staticsUrl;
    this.i18n = i18n(accountLanguage, baseUrl);
    notifyViewStartLoading(COMPONENT_NAME);
  }

  async componentDidMount() {
    try {
      const experiments = await createExperiments();
      const isFontUpgrade = experiments.isEnabled(CrmHomeSpec.MadeforFont);
      this.setState({ initialized: true, isFontUpgrade });
    } catch (_e) {
      this.setState({ initialized: true });
    }
  }

  render() {
    const { initialized, isFontUpgrade } = this.state;
    const biLogger = new CrmHomeBiLogger({ msid: this.props.metaSiteId });
    return initialized ? (
      <I18nextProvider i18n={this.i18n}>
        <FontUpgrade active={isFontUpgrade}>
          <App biLogger={biLogger} moduleParams={this.props} />
        </FontUpgrade>
      </I18nextProvider>
    ) : null;
  }
}
